var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { domainService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject } from "~/core/decorator";
var OutsourceCommissionedService = /** @class */ (function () {
    function OutsourceCommissionedService() {
    }
    /**
     * 委外管理-委外方管理-委外方列表
     */
    OutsourceCommissionedService.prototype.searchCutsourceList = function (data, page, sort) {
        return this.netService.send({
            server: domainService.outsourceCommissionedManageController.searchCutsourceList,
            data: {
                outsName: data.outsName,
                outSourceType: data.outSourceType,
                areaId: data.areaId,
                deptId: data.deptId,
                deptName: data.deptName,
                provinceCode: data.provinceCode,
                outsourceStatus: data.outsourceStatus,
            },
            page: page,
            sort: sort,
        });
    };
    /**
     * 修改委外方
     *
     */
    OutsourceCommissionedService.prototype.modifyCutsource = function (data) {
        return this.netService.send({
            server: domainService.outsourceCommissionedManageController.modifyCutsource,
            data: data
        });
    };
    __decorate([
        Inject(NetService)
    ], OutsourceCommissionedService.prototype, "netService", void 0);
    return OutsourceCommissionedService;
}());
export { OutsourceCommissionedService };
